module.exports = __webpack_public_path__ + "static/media/hotel-manager.021fb978.jpg";